export interface DatedConversation {
  token: string;
  title: string;
  updated_at: string;
}

export interface ConversationGroup<T> {
  label: string;
  items: T[];
}

function startOfDayBefore(days: number, from: Date): Date {
  const date = new Date(from);
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() - days);
  return date;
}

/**
 * Buckets a newest-first list by how recently each thread was touched. A thread
 * lands in the first bucket it still fits, so the groups come back in order and
 * the empty ones are dropped.
 */
export function groupByRecency<T extends DatedConversation>(
  conversations: T[],
  now: Date = new Date(),
): ConversationGroup<T>[] {
  const buckets = [
    { label: "Today", after: startOfDayBefore(0, now), items: [] as T[] },
    { label: "Yesterday", after: startOfDayBefore(1, now), items: [] as T[] },
    { label: "Last 7 days", after: startOfDayBefore(7, now), items: [] as T[] },
    { label: "Older", after: new Date(0), items: [] as T[] },
  ];

  conversations.forEach((conversation) => {
    const updatedAt = new Date(conversation.updated_at);
    buckets.find((bucket) => updatedAt >= bucket.after)?.items.push(conversation);
  });

  return buckets.filter((bucket) => bucket.items.length).map(({ label, items }) => ({ label, items }));
}
